import React, { useState, useEffect } from "react";
import { Layout, Button, QRCode, Modal, message, Avatar } from "antd";
import { ShareAltOutlined } from "@ant-design/icons";
import "./compute.scss";
import axiosInstance from "@/axios/axiosInstance";
import { useNavigate, useLocation } from "react-router-dom";
import tool from "@/assets/tool";
import { setupWechatShare, updateMetaTags } from "@/utils/shareConfig";

const DataDetailPage = () => {
  let navigate = useNavigate();
  const [dataDetail, setDatali] = useState({});
  const [computeData, setComputeData] = useState([]);
  const [user, setUser] = useState({});
  const [qrVisible, setQrVisible] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const profilePictureUrl = queryParams.get("profilePictureUrl");
  const nickName = queryParams.get("nickName");

  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `computPower/page/detail?computPowerId=${id}`
      );
      const data = response.data.data;
      setDatali(data);

      setupWechatShare({
        title: `${data.area} ${data.gpu} ${data.systemEnvironment}`,
        desc: `显存: ${data.graphicsMemory}, 系统环境: ${data.systemEnvironment}`,
      });

      updateMetaTags(
        `${data.area} ${data.gpu}`,
        `显存: ${data.graphicsMemory}, 系统环境: ${data.systemEnvironment}`
      );
    } catch (error) {
      console.error("Error fetching details:", error);
    }
  };

  const getOthCom = async () => {
    try {
      const response = await axiosInstance.get(`computPower/page/list`);
      const compute = response.data.data?.slice(0, 6) || [];
      setComputeData(compute);
    } catch (error) {
      console.error("Error fetching recommendations:", error);
    }
  };

  useEffect(() => {
    if (id) {
      setUser({
        nickName: nickName,
        profilePictureUrl: profilePictureUrl,
      });
      fetchDetails(id);
      getOthCom();
    }
  }, [id, nickName, profilePictureUrl]);

  const toDetail = (record) => {
    const params = new URLSearchParams({
      id: record.computPowerId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    window.location.href = `/computa_detail?${params.toString()}`;
  };

  const getLabel = (l) => {
    let arr = l || "";
    let label = [
      { key: "1", value: "AI绘图" },
      { key: "2", value: "科学计算 " },
      { key: "3", value: "模型渲染" },
      { key: "4", value: "模型推理" },
      { key: "5", value: "模型训练" },
    ];
    let result = [];
    arr.split(",").forEach((v) => {
      let item = label.find((item) => item.key === v);
      if (item) {
        result.push(item);
      }
    });
    return result;
  };

  const neics = [
    { key: 1, value: "2GiB" },
    { key: 2, value: "4GiB " },
    { key: 3, value: "8GiB" },
    { key: 4, value: "16GiB" },
    { key: 5, value: "32GiB" },
    { key: 6, value: "64GiB" },
    { key: 7, value: "128GiB" },
    { key: 8, value: "256GiB" },
    { key: 9, value: "512GiB" },
  ];
  const cpus = [
    { key: 1, value: "1核(vCPU)" },
    { key: 2, value: "2核(vCPU) " },
    { key: 3, value: "4核(vCPU)" },
    { key: 4, value: "8核(vCPU)" },
    { key: 5, value: "16核(vCPU)" },
    { key: 6, value: "32核(vCPU)" },
    { key: 7, value: "48核(vCPU)" },
  ];

  const handleShare = () => {
    setQrVisible(true);
  };

  const copyLink = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        message.success("链接已复制到剪贴板");
      })
      .catch(() => {
        message.error("复制失败，请手动复制");
      });
  };

  const handleBuy = async () => {
    if (!sessionStorage.getItem("token")) {
      message.warning("请先登录");
      navigate("/login");
      return;
    }

    // 构建订单信息
    const orderInfo = dataDetail;

    // 跳转到支付确认页面
    navigate("/compute/pay-confirm", {
      state: { orderInfo },
    });
  };

  return (
    <Layout className="compute_datail">
      <div className="compute-header">
        <div className="header-content">
          <h1 className="title">算力详情</h1>
          <div className="subtitle">
            {dataDetail.area} {dataDetail.gpu} {dataDetail.systemEnvironment}
            <ShareAltOutlined className="share-icon" onClick={handleShare} />
          </div>
          <div className="meta-info">
            <img
              src={`/file/${dataDetail.profilePictureUrl}`}
              className="user-avatar"
              alt="用户头像"
            />
            <span className="username">
              {user.nickName || tool.hideMiddleFour(dataDetail.phone)}
            </span>
            <span className="publish-time">于{dataDetail.createTime}发布</span>
          </div>
          <div className="tags">
            <span className="tag-label">适用场景</span>
            <div className="tag-list">
              {getLabel(dataDetail.useScene).map((v) => (
                <span key={v.key} className="tag">
                  {v.value}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="compute-content">
        <div className="main-content">
          <section className="config-section">
            <div className="table-container">
              <div className="table_name">
                <h3>参数配置</h3>
              </div>
              <div className="row">
                <div className="cell first-third-bg">地域及可用区</div>
                <div className="cell">{dataDetail.area}</div>
                <div className="cell first-third-bg">适用场景</div>
                <div className="cell">
                  {getLabel(dataDetail.useScene).map((v) => {
                    return (
                      <span key={v.key} className="useScene">
                        {v.value}
                      </span>
                    );
                  })}
                </div>
              </div>
              <div className="row">
                <div className="cell first-third-bg">显存</div>
                <div className="cell">{dataDetail.graphicsMemory} GB</div>
                <div className="cell first-third-bg">系统环境</div>
                <div className="cell">{dataDetail.systemEnvironment}</div>
              </div>
              <div className="row">
                <div className="cell first-third-bg">内存</div>
                <div className="cell">
                  {dataDetail.memory
                    ? neics.find((item) => item.key === dataDetail.memory).value
                    : ""}
                </div>
                <div className="cell first-third-bg">CPU</div>
                <div className="cell">
                  {dataDetail.cpu
                    ? cpus.find((item) => item.key === dataDetail.cpu).value
                    : ""}
                </div>
              </div>
              <div className="row">
                <div className="cell first-third-bg">显卡系列</div>
                <div className="cell">{dataDetail.gpu}</div>
                <div className="cell first-third-bg">存储空间</div>
                <div className="cell">{dataDetail.graphicsMemory}GB</div>
              </div>
              <div className="row">
                <div className="cell first-third-bg">网络带宽</div>
                <div className="cell">{dataDetail.width}</div>
                <div className="cell first-third-bg">系统盘</div>
                <div className="cell">{dataDetail.space}GB</div>
              </div>
            </div>
            <div className="table-container">
              <div className="table_name">
                <h3>商品费用</h3>
              </div>
              <div className="row">
                <div className="cell first-third-bg">付费方式</div>
                <div className="cell">
                  {dataDetail.hireType === 1
                    ? "按天"
                    : dataDetail.hireType === 2
                    ? "按月"
                    : "按年"}
                </div>
                <div className="cell first-third-bg">出租时长</div>
                <div className="cell">
                  {dataDetail.hireTime}
                  {dataDetail.hireType === 1
                    ? "天"
                    : dataDetail.hireType === 2
                    ? "月"
                    : "年"}
                </div>
              </div>
              <div className="row">
                <div className="cell first-third-bg">数量</div>
                <div className="cell">1台</div>
                <div className="cell first-third-bg">价格</div>
                <div className="cell">
                  {dataDetail.hirePrice}/
                  {dataDetail.hireType === 1
                    ? "天"
                    : dataDetail.hireType === 2
                    ? "月"
                    : "年"}
                </div>
              </div>
            </div>
          </section>

          <section className="recommendations">
            <h2>推荐算力</h2>
            <div className="recommendation-grid">
              {computeData.map((v) => (
                <div
                  key={v.computPowerId}
                  className="recommendation-card"
                  onClick={() => toDetail(v)}
                >
                  <div className="tuij">GPU特惠精选</div>
                  <div className="cont_san">
                    <div className="cont-l">
                      <div className="title" title={v.systemEnvironment}>
                        {v.gpu} {v.systemEnvironment}
                      </div>

                      <div className="specs-container">
                        <span className="spec-item">
                          CPU：
                          {v.cpu
                            ? cpus.find((item) => item.key === v.cpu).value
                            : ""}
                        </span>
                        <span className="spec-item">
                          内存：
                          {v.memory
                            ? neics.find((item) => item.key === v.memory).value
                            : ""}
                        </span>
                        <span className="spec-item">储存空间：{v.space}GB</span>
                      </div>

                      <div className="specs-container">
                        <span className="spec-item">
                          时长：{v.hireTime}
                          {v.hireType === 1
                            ? "天"
                            : v.hireType === 2
                            ? "月"
                            : "年"}
                        </span>
                        <span className="spec-item">数量：1台</span>
                      </div>

                      <div className="action-area">
                        <div className="price-info">
                          <span className="price">
                            ￥{v.hirePrice * v.hireTime}
                          </span>
                          <span className="unit">
                            /
                            {v.hireType === 1
                              ? "天"
                              : v.hireType === 2
                              ? "月"
                              : "年"}
                          </span>
                        </div>
                        <div className="leng">了解更多</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        <aside className="sidebar">
          <div className="price-card">
            <div className="total-price">
              ￥ {dataDetail.hirePrice * dataDetail.hireTime} 元
            </div>
            <div className="price-details">
              <div className="detail-item">
                <span>购买时长：</span>
                <span>
                  {dataDetail.hireTime}
                  {dataDetail.hireType === 1
                    ? "天"
                    : dataDetail.hireType === 2
                    ? "月"
                    : "年"}
                </span>
              </div>
              <div className="detail-item">
                <span>购买单价：</span>
                <span>
                  {dataDetail.hirePrice} /
                  {dataDetail.hireType === 1
                    ? "天"
                    : dataDetail.hireType === 2
                    ? "月"
                    : "年"}
                </span>
              </div>
              <div className="detail-item">
                <span>购买数量：</span>
                <span>1台</span>
              </div>
            </div>
            <Button
              type="primary"
              size="large"
              className="buy-button"
              loading={loading}
              onClick={handleBuy}
            >
              立即购买
            </Button>
          </div>

          {/* <div className="author-card">
            <div className="author-header">
              <Avatar
                size={48}
                src={dataDetail.authorAvatar || "/default-avatar.png"}
              />
              <div className="author-info">
                <div className="author-name">{dataDetail.authorName}</div>
                <div className="author-title">算力提供者</div>
              </div>
              <Button type="link" className="follow-btn">
                + 关注
              </Button>
            </div>
          </div> */}
        </aside>
      </div>

      <Modal
        title="分享到微信"
        open={qrVisible}
        onCancel={() => setQrVisible(false)}
        footer={null}
        className="share-modal"
      >
        <div className="share-content">
          <div className="qr-section">
            <QRCode value={window.location.href} size={200} />
            <p>微信扫码分享</p>
          </div>
          <div className="share-options">
            <Button onClick={copyLink}>复制链接</Button>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default DataDetailPage;
